import styled from 'styled-components'

export const Container = styled.div<{ $fill?: boolean }>`
  background: ${({ theme }) => theme.colors.background.secondary};
  border-radius: ${({ theme }) => theme.borderRadius.default};
  padding: ${({ theme, $fill }) =>
    $fill ? `0 ${theme.spacing.medium} ${theme.spacing.medium}` : theme.spacing.medium};
  border: 1px solid ${({ theme }) => theme.colors.border.default};
  ${({ $fill }) =>
    $fill &&
    `
      height: 100%;
      display: flex;
      flex-direction: column;
      border: none;
      background: transparent;
    `}
`

export const HeaderRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-bottom: ${({ theme }) => theme.spacing.small};
`

export const CloseButton = styled.button`
  background: transparent;
  border: none;
  padding: ${({ theme }) => theme.spacing.xsmall};
  cursor: pointer;
  color: ${({ theme }) => theme.colors.text.secondary};
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: ${({ theme }) => theme.borderRadius.small};
  transition: ${({ theme }) => theme.transitions.fast};

  &:hover {
    background: ${({ theme }) => theme.colors.background.tertiary};
    color: ${({ theme }) => theme.colors.text.primary};
  }
`

export const FiltersList = styled.div<{ $fill?: boolean }>`
  max-height: ${({ $fill }) => ($fill ? 'none' : '300px')};
  flex: ${({ $fill }) => ($fill ? '1' : '0 0 auto')};
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.small};
`

export const FilterItem = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${({ theme }) => theme.spacing.small};
  padding: ${({ theme }) => theme.spacing.default} ${({ theme }) => theme.spacing.medium};
  background: ${({ theme }) => theme.colors.background.primary};
  border-radius: ${({ theme }) => theme.borderRadius.xlarge};
  border: 1px solid ${({ theme }) => theme.colors.border.light};
  transition: ${({ theme }) => theme.transitions.fast};

  &:hover {
    border-color: ${({ theme }) => theme.colors.border.default};
  }
`

export const FilterName = styled.span`
  color: ${({ theme }) => theme.colors.text.primary};
  font-size: ${({ theme }) => theme.typography.fontSize.body};
  flex: 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`

export const FilterActions = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.xsmall};
  margin-left: ${({ theme }) => theme.spacing.small};
  flex-shrink: 0;
`

export const ApplyButton = styled.button`
  border: none;
  background: transparent;
  padding: ${({ theme }) => theme.spacing.xsmall} ${({ theme }) => theme.spacing.small};
  border-radius: ${({ theme }) => theme.borderRadius.default};
  color: ${({ theme }) => theme.colors.text.tertiary};
  font: inherit;
  font-size: ${({ theme }) => theme.typography.fontSize.small};
  cursor: pointer;
  transition: ${({ theme }) => theme.transitions.fast};

  &:hover {
    background: ${({ theme }) => theme.colors.background.tertiary};
    color: ${({ theme }) => theme.colors.text.primary};
  }
`

export const MenuList = styled.div`
  display: flex;
  flex-direction: column;
  margin: -${({ theme }) => theme.spacing.medium};
`

export const MenuItem = styled.button<{ $danger?: boolean }>`
  border: none;
  background: transparent;
  text-align: left;
  padding: ${({ theme }) => theme.spacing.default} ${({ theme }) => theme.spacing.medium};
  color: ${({ theme, $danger }) => ($danger ? theme.colors.danger : theme.colors.text.primary)};
  font: inherit;
  font-size: ${({ theme }) => theme.typography.fontSize.body};
  cursor: pointer;

  &:hover {
    background: ${({ theme }) => theme.colors.background.secondary};
  }
`

export const EmptyMessage = styled.p`
  margin: 0;
  color: ${({ theme }) => theme.colors.text.secondary};
  font-size: ${({ theme }) => theme.typography.fontSize.small};
  line-height: 1.5;
`

export const SuccessMessage = styled.div`
  margin-top: ${({ theme }) => theme.spacing.small};
  padding: ${({ theme }) => theme.spacing.small};
  background: ${({ theme }) => `${theme.colors.success}1A`};
  color: ${({ theme }) => theme.colors.text.primary};
  font-size: ${({ theme }) => theme.typography.fontSize.small};
  border-radius: ${({ theme }) => theme.borderRadius.small};
  animation: fadeIn 0.2s ease-in;

  @keyframes fadeIn {
    from {
      opacity: 0;
      transform: translateY(-4px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
`
